module.exports = "../../app/cells/components/unlimited_access_cell.rb";